<main class="flex flex-row min-w-[900px] min-h-screen">
  <section class="w-[50%] bg-[#27368a] flex items-center justify-center">
    <figure class="text-center">
      <img src="../../../assets/img/logo_cangas_aventura_blank.png" class="block mx-auto w-[60%]"
        alt="logo cangas aventura">
    </figure>
  </section>
  <section class="w-[50%] flex items-center justify-center">
    <div class="w-[50%] min-w-[200px] max-w-[300px]">
      <h5 class="text-[#27368A] font-bold text-lg mb-1" *ngIf="currentView == 'login'">Acceder a Cangas Aventura</h5>
      <h5 class="text-[#27368A] font-bold text-lg mb-1" *ngIf="currentView == 'offices'">Seleccione una oficina</h5>
      <p class="text-red-500" *ngIf="loginFailed">Los datos ingresados no coinciden con ningún usuario</p>
      <form class="mt-3" [formGroup]="formLogin" (ngSubmit)="login()" *ngIf="currentView == 'login'">
        <div class="">
          <div class="mb-2">
            <label for="number" class="text-[#27368A] block">Código empleado</label>
            <input type="text" tabindex="1" formControlName="employee_code" class="form-control">
          </div>
          <div>
            <label for="password" class="text-[#27368A] block">Contraseña</label>
            <input type="password" tabindex="2" formControlName="password" class="form-control">

          </div>
          <div class="card flex flex-row justify-content-center mt-2">
            <p-checkbox [binary]="true" inputId="binary" [tabindex]="3" formControlName="checkedRemember"></p-checkbox>
            <p class="text-[#27368A] text-xs pl-1">Recordar</p>
          </div>
          <div class="btn-submit-container">
            <button type="submit" [disabled]="!formLogin.valid" class="btn-submit mx-auto">Aceptar</button>
          </div>
        </div>
        <div class="text-center mt-2">
          <button routerLink="/recovery" class="text-[#27368A] text-xs outline-none text-center mt-4 mx-auto">¿Olvidaste
            tu contraseña?</button>
        </div>
      </form>
      <section *ngIf="currentView == 'offices'">
        <ul>
          <li *ngFor="let office of offices" class="office-item">
            <div *ngIf="office.has_open_cashier" class="border border-gray-300  text-center px-2 py-2 font-bold mb-1 rounded-[10px] bg-white">
              <p class="text-gray-300 text-[14px] pl-1">{{office.name}}</p>
            </div>
            <div *ngIf="!office.has_open_cashier"
              class="border border-gray-300 hover:border-l-4 hover:border-l-[#DB071B] hover:border-r-4 hover:border-r-[#DB071B] text-center px-2 py-2 font-bold mb-1 cursor-pointer rounded-[10px] bg-white transition-all"
              (click)="enterToSystem(office.id)">
              <p class="text-[#27368A] text-[14px] pl-1 hover:text-[#DB071B] transition-all">{{office.name}}</p>
            </div>

          </li>
        </ul>
        <div class="btn-submit-container">
          <button type="button" class="btn-submit mx-auto" (click)="currentView = 'login'">Ir a login</button>
        </div>
      </section>
    </div>
  </section>
</main>
